import React, { Component } from 'react';
import AuthService from '../auth/AuthService';
const Auth = new AuthService();

class Header extends Component {
	handleLogout(){
	    Auth.logout()
	    this.props.history.replace('/login');
	 }

	render() {
		return (
			<header className="header">
					{this.props.user ?
						<div className="userinfo">
							<img src="/images/assets/loggetind.svg" alt="" />
							<div>Logget ind som {this.props.user.name}</div>
							<button className="link-button" onClick={this.handleLogout.bind(this)}>Log ud</button>
						</div>
				 	: 	<div className="userinfo">
				 			<img src="/images/assets/ikkeloggetind.svg" alt="" />
				 			<div>Ikke logget ind</div>
				 		</div>
				 	}
				<h1>Trossamfundsregistret</h1>
				{this.props.children}
			</header>
			)
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/modules/common/Header.js